import { PALockDataAction } from "./constants";
import { RunPACheckLockData } from "./types";

export const paCheckLockedData = (data: RunPACheckLockData[] = []) => {
  return !data.length
    ? false
    : data?.every((item) => item.action === PALockDataAction.LOCK);
};
